import React from "react";

import {
  FieldErrorText,
  FieldLabel,
  FormField,
  FormInput,
  FormSelect,
  PrimaryActionButton,
  SectionFormGrid,
  TwoColumnFieldGrid,
} from "pages/app/workspace/sections/styles/workspace-section.styles";

type WalletTopUpFormProps = {
  amount: string;
  amountError?: string;
  isSubmitting: boolean;
  onAmountChange: (value: string) => void;
  onSubmit: () => void;
  submitDisabled: boolean;
};

export const WalletTopUpForm: React.FC<WalletTopUpFormProps> = ({
  amount,
  amountError,
  isSubmitting,
  onAmountChange,
  onSubmit,
  submitDisabled,
}) => (
  <TwoColumnFieldGrid>
    <FormField>
      <FieldLabel>Top-up amount</FieldLabel>
      <FormInput
        aria-invalid={Boolean(amountError)}
        min="0"
        onChange={(event) => onAmountChange(event.target.value)}
        placeholder="0.00"
        type="number"
        value={amount}
      />
      {amountError ? <FieldErrorText>{amountError}</FieldErrorText> : null}
    </FormField>

    <PrimaryActionButton disabled={submitDisabled} onClick={onSubmit} type="button">
      {isSubmitting ? "Topping up..." : "Top up"}
    </PrimaryActionButton>
  </TwoColumnFieldGrid>
);

type WalletTransferFormProps = {
  description: string;
  isSubmitting: boolean;
  onDescriptionChange: (value: string) => void;
  onRecipientChange: (value: string) => void;
  onSubmit: () => void;
  onTransferAmountChange: (value: string) => void;
  recipientError?: string;
  recipientUserId: string;
  recipients: any[];
  submitDisabled: boolean;
  transferAmountError?: string;
  transferAmount: string;
};

export const WalletTransferForm: React.FC<WalletTransferFormProps> = ({
  description,
  isSubmitting,
  onDescriptionChange,
  onRecipientChange,
  onSubmit,
  onTransferAmountChange,
  recipientError,
  recipientUserId,
  recipients,
  submitDisabled,
  transferAmountError,
  transferAmount,
}) => (
  <SectionFormGrid>
    <FormField>
      <FieldLabel>Recipient user</FieldLabel>
      {recipients.length > 0 ? (
        <FormSelect
          aria-invalid={Boolean(recipientError)}
          onChange={(event) => onRecipientChange(event.target.value)}
          value={recipientUserId}
        >
          <option value="">Select a user</option>
          {recipients.map((user: any) => (
            <option key={user.id} value={user.id}>
              {user.full_name || user.email}
            </option>
          ))}
        </FormSelect>
      ) : (
        <FormInput
          aria-invalid={Boolean(recipientError)}
          onChange={(event) => onRecipientChange(event.target.value)}
          placeholder="Recipient user UUID"
          value={recipientUserId}
        />
      )}
      {recipientError ? <FieldErrorText>{recipientError}</FieldErrorText> : null}
    </FormField>

    <FormField>
      <FieldLabel>Transfer amount</FieldLabel>
      <FormInput
        aria-invalid={Boolean(transferAmountError)}
        min="0"
        onChange={(event) => onTransferAmountChange(event.target.value)}
        placeholder="0.00"
        type="number"
        value={transferAmount}
      />
      {transferAmountError ? <FieldErrorText>{transferAmountError}</FieldErrorText> : null}
    </FormField>

    <FormField>
      <FieldLabel>Description</FieldLabel>
      <FormInput
        onChange={(event) => onDescriptionChange(event.target.value)}
        placeholder="Optional description"
        value={description}
      />
    </FormField>

    <PrimaryActionButton disabled={submitDisabled} onClick={onSubmit} type="button">
      {isSubmitting ? "Transferring..." : "Transfer funds"}
    </PrimaryActionButton>
  </SectionFormGrid>
);
